import SFetch from '@app/utils/sfetch'

export const saveAccumulatedTime = ({
  ownerId,
  ownerType,
  firmId,
  companyId,
  ledgerId,
  durationInSeconds,
}: {
  ownerId: number
  ownerType: string
  firmId: string
  companyId: string
  ledgerId: number
  durationInSeconds: number
}): Promise<null> => {
  const url = window.Silverfin.Routes.wall_clock_time_entries_path(
    firmId,
    companyId
  )

  return SFetch.json(url, {
    method: 'POST',
    body: {
      wall_clock_time_entry: {
        ledger_id: ledgerId,
        owner_id: ownerId,
        owner_type: ownerType,
        duration_in_seconds: durationInSeconds,
      },
    },
  })
}
